module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAZ0lEQVR4Ae3ZAQbAQBAEwTx9fn6BY+UFa6KaBmAaB3sPfgGAXGvHn2t6x4/pHT+md/yY3vFjesePaR5f8SbOx1UECBAgYDVYgAABAgTsI0CAAAGOAMsRcQhbiohjcMc53oeIL6kBAF5l+u8h8WBSdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_import_export_black_24dp.png
// module id = 68
// module chunks = 0